import { ErrandInterface } from '../errands/errand.model';

export class LabelStateModel {
  id: string;
  title: string | null = null;
  description: string | null = null;
  errands: ErrandInterface[] = [];
}
